import { create } from "zustand";
import WorktimeService from "../api/worktimeService";
import { WorktimeSchedule } from "../models/worktimeSchedule";
import { convertWorkScheduleToLocal, convertWorkScheduleToUTC } from "../helpers/dateHelper";

interface WorktimeStore {
  worktimes: WorktimeSchedule | null;
  fetchWorktimes: () => Promise<void>;
  setWorktimes: (worktimes: WorktimeSchedule) => void;
}

const convertUTCToLocal = (utcDateStr: string): Date => {
  const utcDate = new Date(utcDateStr);
  return utcDate;
};
export const useWorktimeStore = create<WorktimeStore>((set) => ({
  worktimes: null,
  fetchWorktimes: async () => {
    const worktimeService = new WorktimeService();
    try {
      const workTimeUtc = await worktimeService.getWorktimes();

      /*const worktimes = {
        open: convertUTCToLocal(workTimeUtc.open.toString()),
        close: convertUTCToLocal(workTimeUtc.close.toString()),
        schedules: convertWorkScheduleToLocal(workTimeUtc.schedules),
      };*/

     /* const worktimes = {
        open: convertUTCToLocal(workTimeUtc.open),
        close: convertUTCToLocal(workTimeUtc.close),
        schedule: workTimeUtc.schedule
      };*/

      const worktimes = {
        open: new Date(workTimeUtc.open),
        close: new Date(workTimeUtc.close),
        schedules: convertWorkScheduleToUTC(workTimeUtc.schedules),
      };

      set({ worktimes });
    } catch (error) {
      console.error("Failed to fetch worktimes:", error);
    }
  },
  setWorktimes: (worktimes) => set({ worktimes }),
}));
